export default __webpack_public_path__ + "static/media/LENS_CULINARIS_ATHILA_complete_7.349922b1.jpg";